import { ReactNode } from "react"
import { useLocation, useNavigate } from "react-router-dom"

import { useAppSelector } from "../../redux"
import {
  ListItemButton,
  Box,
  ListItemIcon,
  ListItemText,
  ListSubheader,
} from "@podcastsoundboard/ps-lib/ui"
import BookIcon from "@podcastsoundboard/ps-lib/ui/icons/Book"
import FormatListBulletedIcon from "@podcastsoundboard/ps-lib/ui/icons/FormatListBulleted"
import PersonIcon from "@podcastsoundboard/ps-lib/ui/icons/Person"

const NavListItem = (props: { path: string; children: ReactNode }) => {
  const { path } = props

  const navigate = useNavigate()
  const location = useLocation()

  return (
    <ListItemButton
      selected={location.pathname.startsWith(path)}
      onClick={() => navigate(path)}
    >
      {props.children}
    </ListItemButton>
  )
}

export const AdminListItems = () => {
  const darkModeEnabled = useAppSelector((state) => state.darkModeEnabled)
  return (
    <Box>
      <NavListItem path="/app/admin/users">
        <ListItemIcon>
          <PersonIcon />
        </ListItemIcon>
        <ListItemText primary="Users" />
      </NavListItem>
      <NavListItem path="/app/admin/soundboards">
        <ListItemIcon>
          <FormatListBulletedIcon />
        </ListItemIcon>
        <ListItemText primary="Soundboards" />
      </NavListItem>
      <NavListItem path="/app/admin/blogposts">
        <ListItemIcon>
          <BookIcon />
        </ListItemIcon>
        <ListItemText primary="Blog Posts" />
      </NavListItem>
      <NavListItem path="/app/admin/windows-licenses">
        <ListItemIcon>
          <img
            style={{
              height: "1.3rem",
              width: "1.3rem",
              paddingLeft: "3px",
              opacity: darkModeEnabled ? 1 : 0.6,
            }}
            alt="Windows"
            src={
              darkModeEnabled ? "/img/windows.svg" : "/img/windows-black.svg"
            }
          />
        </ListItemIcon>
        <ListItemText primary="Windows Licenses" />
      </NavListItem>
    </Box>
  )
}

// eslint-disable-next-line react-refresh/only-export-components
export const secondaryListItems = (
  <div>
    <ListSubheader className="pl-14">System</ListSubheader>
  </div>
)
